import { ApplicationConfig, ApplicationSection, FieldType } from '@bybeam/platform-types';

const SECTIONS: ApplicationSection[] = [
  {
    key: 'learnMore',
    name: 'EDCKC Revolving Loan Fund',
    overview: {
      description: 'Learn more about this program',
      title: 'EDCKC Revolving Loan Fund',
    },
    questionGroups: [
      {
        key: 'learnMore',
        name: 'EDCKC Revolving Loan Fund',
        questions: [
          {
            key: 'link',
            copy: { title: 'EDCKC Revolving Loan Fund' },
            layout: 'panel',
            fields: [
              {
                key: 'link',
                type: FieldType.Typography,
                copy: `
EDC Loan Corporation (EDCLC) is a nonprofit corporation specializing in the origination and underwriting of Revolving Loan Funds. Its mission is to help small businesses grow and expand through loan programs to attract, expand, and retain jobs.

EDCLC's Revolving Loan Fund (RLF) assists small businesses with expansion with conventional bank financing is not possible. Funds for this program are provided by the U.S. Economic Development Administration.

Projects eligible for financing:
- For-profit business
- Not-for-debt refinancing
- Located within Kansas City, Missouri city limits
- Must have been in business for at least two (2) years.

To learn more and apply visit: [https://edckc.com/agencies/edc-loan-corporation-edcl/](https://edckc.com/agencies/edc-loan-corporation-edcl/)
                `,
                props: { variant: 'largeBody', alignment: 'left' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'attestation',
    name: 'Attestation',
    overview: {
      title: 'Attestation',
      description: '',
    },
    questionGroups: [
      {
        key: 'attestation',
        name: 'Attestation',
        questions: [
          {
            key: 'attestation',
            copy: { title: 'Attestation' },
            layout: 'panel',
            fields: [
              {
                key: 'attestation.info',
                type: FieldType.Typography,
                copy: 'I understand that to apply for this program, I must visit the external site: [https://edckc.com/agencies/edc-loan-corporation-edcl/](https://edckc.com/agencies/edc-loan-corporation-edcl/)',
                props: { variant: 'largeBody', alignment: 'center' },
              },
              {
                key: 'attestation.confirm',
                type: FieldType.Checkbox,
                copy: 'I confirm.',
              },
            ],
          },
        ],
      },
    ],
  },
];

const CONFIG: ApplicationConfig = {
  introPages: [],
  overrides: {
    statuses: [
      {
        status: 'Application',
        label: '',
        message:
          'This is an external program with its own application. To apply, visit [https://edckc.com/agencies/edc-loan-corporation-edcl/](https://edckc.com/agencies/edc-loan-corporation-edcl/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
      {
        status: 'InProgress',
        label: '',
        message:
          'This is an external program with its own application. To apply, visit [https://edckc.com/agencies/edc-loan-corporation-edcl/](https://edckc.com/agencies/edc-loan-corporation-edcl/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
    ],
    submission: {
      title: 'What happens next?',
      bullets: [
        {
          key: 'review',
          title: 'Application review',
          icon: 'description',
          description:
            'While we look at your application, we might send you an email to ask for more information or notify you of next steps',
        },
      ],
    },
  },
  sections: SECTIONS,
};

export default CONFIG;
